import {api} from 'apis/configs/axiosConfigs'
import {useEffect, useState} from 'react'
import {Card, CardBody, Table, TableCaption, TableContainer, Tbody, Th, Thead, Tr, Stack, Checkbox} from '@chakra-ui/react'
import {RowsEmptyRow} from './RowsEmptyTable/RowsEmptyRow'
import {Captions} from '../Captions'


export const RowsEmpty = (props) => {
    const {countingId} = props
    const [rowsEmpty, setRowsEmpty] = useState([])

    const [isWithNotClosed, setIsWithNotClosed] = useState(false)

    const headerRows = ['Row', 'Amount', 'Name', 'Device', 'Time', 'Date']

    const getRowsEmpty = async (countingId) => {
            const response = await api.request({
                url: `/rows/empty/${countingId}`,
                method: 'GET',
                params: { ... isWithNotClosed ? { with_not_closed: 1 } : {} },
            })
    
            return response.data
        }
    
    const fetchRowsEmpty = async (countingId) => {
        const resp = await getRowsEmpty(countingId)
        if (resp?.rows_empty) {
            setRowsEmpty(resp.rows_empty)
        }
    }

    useEffect(() => {
        fetchRowsEmpty(countingId)
    }, [countingId, isWithNotClosed])
    return (
        <Card>
            <CardBody>
                <TableContainer>
                    <Table>
                        <TableCaption placement={'top'}>
                            <Captions total={rowsEmpty.length} />
                            <Stack direction='row' spacing={4}>
                                <Checkbox isChecked={isWithNotClosed} onChange={(e) => {
                                    setIsWithNotClosed(e.target.checked)
                                }}>Include Not Closed</Checkbox>
                            </Stack>
                        </TableCaption>
                        <Thead>
                            <Tr>
                                {headerRows.map((header) => (
                                    <Th key={header}>
                                        {header}
                                    </Th>
                                ))}
                            </Tr>
                        </Thead>
                        <Tbody>
                        {rowsEmpty.map(rowEmpty => (
                            <RowsEmptyRow
                                key={rowEmpty._id}
                                name={rowEmpty.name}
                                date={rowEmpty.created_at}
                                userFirstName={rowEmpty?.user?.name}
                                userLastName={rowEmpty?.user?.last_name}
                                deviceNumber={rowEmpty.device_number}
                            />
                        ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            </CardBody>
        </Card>
    )
}